import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Ambetter Marketplace",
  shortName: "Ambetter",
  slug: "ambetter-marketplace-insurance",
  seoTitle: "Ambetter Marketplace TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have an Ambetter Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "Ambetter Marketplace TMS coverage, Ambetter TMS therapy, Ambetter ACA depression treatment Florida, Ambetter Marketplace mental health benefits, Ambetter SAINT TMS",
  planType:
    "Health Insurance Marketplace plan (ACA / Healthcare.gov, Centene subsidiary)",
  planRegion: "Florida and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health and substance use services",
  planSpecificIntro:
    "Ambetter is a health insurance brand offered exclusively through the Health Insurance Marketplace (Healthcare.gov), underwritten by Centene Corporation. These ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Ambetter Marketplace plans come in different metal tiers — Bronze, Silver, Gold, and Platinum — coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan tier, deductible, and network.",
  officialResourceUrl: "https://www.ambetterhealth.com/",
  officialResourceLabel: "Ambetter Marketplace plans",
};

export const AmbetterMarketplaceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AmbetterMarketplaceInsurance;
